import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter, Youtube } from 'lucide-react';
import { useTenantStore } from '@/app/stores';
import { Container } from '@/components/ui/Layout';
import { Logo } from './Header';

const col = 'space-y-2.5 text-sm text-secondary-foreground/70';
const link = 'hover:text-white';

export function Footer() {
  const t = useTenantStore((s) => s.tenant);
  const groups = t.navigation?.footer ?? [];
  const socials = [
    { key: 'instagram', icon: Instagram }, { key: 'facebook', icon: Facebook }, { key: 'x', icon: Twitter }, { key: 'youtube', icon: Youtube },
  ] as const;
  return (
    <footer className="mt-12 bg-secondary text-secondary-foreground">
      <Container className="grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-5">
        <div className="space-y-4 lg:col-span-2">
          <Logo onDark />
          <p className="max-w-sm text-sm text-secondary-foreground/70">{t.tagline}. Curated products, secure checkout and rewards on every order.</p>
          <div className="flex gap-2">
            {socials.filter((s) => t.social[s.key]).map(({ key, icon: Icon }) => (
              <a key={key} href={t.social[key]} aria-label={key} className="grid size-9 place-items-center rounded-full bg-white/10 hover:bg-white/20"><Icon className="size-4" /></a>
            ))}
          </div>
        </div>
        {groups.map((g) => (
          <div key={g.id}>
            <h4 className="mb-3 font-bold">{g.title}</h4>
            <ul className={col}>
              {g.items.filter((i) => i.enabled && (!i.feature || t.features[i.feature])).map((i) => (
                <li key={i.id}>{/^https?:\/\//.test(i.to) ? <a className={link} href={i.to} target="_blank" rel="noreferrer">{i.label}</a> : <Link className={link} to={i.to}>{i.label}</Link>}</li>
              ))}
            </ul>
          </div>
        ))}
        <div>
          <h4 className="mb-3 font-bold">Contact</h4>
          <ul className={col}>
            <li className="flex gap-2"><Mail className="mt-0.5 size-4 shrink-0" />{t.contact.email}</li>
            <li className="flex gap-2"><Phone className="mt-0.5 size-4 shrink-0" />{t.contact.phone}</li>
            <li className="flex gap-2"><MapPin className="mt-0.5 size-4 shrink-0" />{t.contact.address}</li>
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10">
        <Container className="flex flex-col items-center justify-between gap-2 py-5 text-xs text-secondary-foreground/60 sm:flex-row">
          <p>© {new Date().getFullYear()} {t.name}. All rights reserved.</p>
          <p>Powered by MCE — Modular Commerce Engine</p>
        </Container>
      </div>
    </footer>
  );
}
